module.exports = __webpack_public_path__ + "img/bg.74d3a62a.png";